import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import AddToCart from 'Component/AddToCart';
import Popup from 'Component/Popup';
import PRODUCT_TYPE from 'Component/Product/Product.config';
import ProductBundleOptions from 'Component/ProductBundleOptions';
import ProductConfigurableAttributes from 'Component/ProductConfigurableAttributes/ProductConfigurableAttributes.container';
import ProductPrice from 'Component/ProductPrice';
import YBRecomendadorTalla from 'Component/YBRecomendadorTalla';
import { GRID_LAYOUT } from 'Route/CategoryPage/CategoryPage.config';
import {
    Product as SourceProduct
} from 'SourceComponent/Product/Product.component';
import { showPopup } from 'Store/Popup/Popup.action';
import getStore from 'Util/Store';

import './Product.override.style';

/** @namespace Elganso/Component/Product/Component/showGuiaDeTallas */
export function showGuiaDeTallas() {
    const store = getStore();
    const { dispatch } = store;
    dispatch(showPopup('guia_de_tallas', { title: __('Size Guide') }));
}

/** @namespace Elganso/Component/Product/Component */
export class Product extends SourceProduct {
    renderCustomAndBundleOptions() {
        const { product: { type_id, id, sku }, configFormRef } = this.props;
        const identificador = `form-id-${ id}`;

        return (
            <div className="product-add-form">
                <form ref={ configFormRef } id={ identificador } data-product-sku={ sku }>
                    { type_id === PRODUCT_TYPE.bundle && this.renderBundleOptions() }
                    { this.renderCustomizableOptions() }
                </form>
            </div>
        );
    }

    renderBundleOptions() {
        const {
            product,
            product: {
                items
            } = {},
            updateSelectedValues
        } = this.props;

        return (
            <ProductBundleOptions
              product={ product }
              options={ items }
              updateSelectedValues={ updateSelectedValues }
            />
        );
    }

    renderConfigurableOptions() {
        const {
            setActiveProduct,
            parameters,
            product: { type_id: type, variants = {} },
            inStock,
            addToCartTriggeredWithError,
            updateAddToCartTriggeredWithError,
            onChangeColor,
            addToCart,
            product
        } = this.props;

        if (type !== PRODUCT_TYPE.configurable) {
            return null;
        }

        return (
            <div
              block="ProductActions"
              elem="AttributesWrapper"
            >
                <ProductConfigurableAttributes
                  numberOfPlaceholders={ [2, 4] }
                  updateAddToCartTriggeredWithError={ updateAddToCartTriggeredWithError }
                  addToCartTriggeredWithError={ addToCartTriggeredWithError }
                  mix={ { block: this.className, elem: 'Attributes' } }
                  parameters={ parameters }
                  variants={ variants }
                  updateConfigurableVariant={ setActiveProduct }
                  configurable_options={ this.getConfigurableAttributes() }
                  isContentExpanded
                  inStock={ inStock }
                  showProductAttributeAsLink={ false }
                  product={ product }
                  onChangeColor={ onChangeColor }
                  addToCart={ addToCart }
                />
            </div>
        );
    }

    renderConfigurableOptionsMobile() {
        const {
            setActiveProduct,
            parameters,
            product: { type_id: type, variants = {} },
            inStock,
            addToCartTriggeredWithError,
            updateAddToCartTriggeredWithError,
            onChangeColor,
            addToCart,
            product
        } = this.props;

        if (type !== PRODUCT_TYPE.configurable) {
            return null;
        }

        return (
            <div
              block="ProductActions"
              elem="AttributesWrapper ProductActionsMobile"
            >
                <ProductConfigurableAttributes
                  numberOfPlaceholders={ [2, 4] }
                  updateAddToCartTriggeredWithError={ updateAddToCartTriggeredWithError }
                  addToCartTriggeredWithError={ addToCartTriggeredWithError }
                  mix={ { block: this.className, elem: 'Attributes' } }
                  parameters={ parameters }
                  variants={ variants }
                  updateConfigurableVariant={ setActiveProduct }
                  configurable_options={ this.getConfigurableAttributes() }
                  isContentExpanded
                  inStock={ inStock }
                  showProductAttributeAsLink={ false }
                  product={ product }
                  onChangeColor={ onChangeColor }
                  addToCart={ addToCart }
                />

                { this.renderYBRecomendadorTallas() }
            </div>
        );
    }

    renderYBRecomendadorTallas() {
        const { product } = this.props;

        if (product.type_id !== PRODUCT_TYPE.bundle) {
            return (
                <YBRecomendadorTalla
                  product={ product }
                />
            );
        }

        return null;
    }

    renderPopupOutOfStock() {
        const id_prop_up_out_of_stock = `outofstock-popup-${ this.props.product.sku}`;

        return (
            <Popup
              id={ id_prop_up_out_of_stock }
              clickOutside={ false }
              mix={ { block: 'OutOfStockForm', elem: 'Popup' } }
            >
                <h1 className="title_suscripcion">
                    { __('Dinos tu email y te avisaremos cuando el producto vuelva a estar disponible') }
                </h1>
            </Popup>
        );
    }

    checkUnselectedOptions() {
        let unselectedOptions = [];
        const { product, parameters } = this.props;
        if (product?.sku) {
            const { configurable_options } = product;
            unselectedOptions = Object.keys(configurable_options).reduce((accumulator, value) => {
                if (!parameters[value]) {
                    accumulator.push(value);
                }

                return accumulator;
            }, []);
        }

        return unselectedOptions;
    }

    renderAddToCartButton(layout = GRID_LAYOUT, isProductCard = false) {
        const {
            addToCart,
            inStock,
            quantity,
            getActiveProduct,
            onSuscribeOutOfStock
        } = this.props;

        if (inStock) {
            const unselectedOptions = this.checkUnselectedOptions();
            return (
                <AddToCart
                  mix={ { block: this.className, elem: 'AddToCart' } }
                  addToCart={ addToCart }
                  isDisabled={ !inStock }
                  isIconEnabled={ false }
                  unselectedOptions={ unselectedOptions }
                  layout={ layout }
                  quantity={ quantity }
                  product={ getActiveProduct() }
                  isProductCard={ isProductCard }
                />
            );
        }

        return (
                <button
                  onClick={ onSuscribeOutOfStock }
                  block="Button ShowPopupAddToCart"
                >
                    <span>{ __('Agotado') }</span>
                        <FontAwesomeIcon
                          className="faEnvelope"
                          icon={ faEnvelope }
                        />
                </button>
        );
    }

    renderSku() {
        const { getActiveProduct } = this.props;
        const { sku } = getActiveProduct();

        return (
            <div className="ProductPageSku">
                <strong className="type">{ __('Ref. ') }</strong>
                <span className="value" itemProp="sku">{ sku.split('-')[0] }</span>
            </div>
        );
    }

    renderPrice(isPreview = false) {
        const {
            getActiveProduct,
            productPrice,
            productoActivo,
            parameters: {
                color
            }
        } = this.props;
        const product = getActiveProduct();

        const {
            sku,
            type_id: type,
            price_tiers: priceTiers,
            variants
        } = product;

        if (!productPrice) {
            return null;
        }

        let skuActivo = sku;

        if (productoActivo === undefined && type === 'configurable') {
            // eslint-disable-next-line array-callback-return, consistent-return
            variants.some((childProduct) => {
                if (childProduct.attributes.color.attribute_value === color) {
                    skuActivo = childProduct.sku;
                    return true;
                }
            });
        } else {
            skuActivo = productoActivo?.sku ? productoActivo?.sku : sku;
        }

        return (
            <div
              block={ this.className }
              elem="PriceWrapper"
            >
                <ProductPrice
                  meta
                  product={ product }
                  skuActivo={ skuActivo }
                  price={ productPrice }
                  priceType={ type }
                  tierPrices={ priceTiers }
                  isPreview={ isPreview }
                  mix={ { block: this.className, elem: 'Price' } }
                />
            </div>
        );
    }
}

export default Product;
